import { z } from 'zod'

export const driverSchema = z.object({
  name: z.string().min(1, 'Nome obrigatório').max(100),
  cpf: z.string().regex(/^\d{11}$/, 'CPF deve ter 11 dígitos'),
  rg: z.string().max(20).optional(),
  phone: z.string().regex(/^\d{10,11}$/, 'Telefone inválido').optional().or(z.literal('')),
  email: z.email('Email inválido').optional().or(z.literal('')),
  driverType: z.enum(['OWN', 'AGGREGATE'], { error: 'Tipo de vínculo obrigatório' }),
  cnhNumber: z.string().max(20).optional(),
  cnhCategory: z.array(z.enum(['A', 'B', 'C', 'D', 'E'])).optional().default([]),
  cnhExpiry: z.string().optional(),
  zipCode: z.string().regex(/^\d{8}$/, 'CEP inválido').optional().or(z.literal('')),
  street: z.string().max(150).optional(),
  number: z.string().max(10).optional(),
  complement: z.string().max(50).optional(),
  neighborhood: z.string().max(100).optional(),
  city: z.string().max(100).optional(),
  state: z.string().length(2, 'UF deve ter 2 caracteres').optional().or(z.literal('')),
  bankName: z.string().max(100).optional(),
  bankAgency: z.string().max(20).optional(),
  bankAccount: z.string().max(20).optional(),
  bankAccountType: z.enum(['corrente', 'poupanca']).optional().or(z.literal('')),
  pixKey: z.string().max(150).optional(),
})

export type DriverFormData = z.infer<typeof driverSchema>
